import { useAppDispatch } from 'store';

import CriticalBloodGlucoseModal from './critical-blood-glucose-modal';
import CriticalBloodPressureModal from './critical-blood-pressure-modal';
import CriticalPulseModal from './critical-pulse-modal';
import CriticalSpo2Modal from './critical-spo2-modal';
import CriticalChfWeightModal from './critical-chf-weight-modal';
import CriticalWeightModal from './critical-weight-modal';

import type { FC } from 'react';
import type { IRpmAlertAssessmentModalsProps } from './types';

const RpmAlertAssessmentModals: FC<IRpmAlertAssessmentModalsProps> = (
  props,
) => {
  const {
    readingId,
    createdAt,
    idx,
    patientGuid,
    values,
    openPressureModal,
    openPressureMinModal,
    readingCriticalType,
    pulseMaxCritical,
    toggleOpenPressure,
    toggleOpenPressureMin,
    toggleAssessmentModal,
    isOpenAssessmentModalMap,
  } = props;

  const {
    activityActions: { updateAction },
  } = useAppDispatch();

  return (
    <>
      {openPressureModal && (
        <CriticalBloodPressureModal
          isOpen={openPressureModal}
          activityId={readingId}
          activityDate={createdAt}
          closeModal={toggleOpenPressure}
          handleSubmit={(msg: string) => {
            updateAction({
              idx,
              action: { message: msg, isTemplateBased: true },
            });
          }}
          values={values}
          type="max"
          patientGuid={patientGuid}
          idx={idx}
        />
      )}

      {openPressureMinModal && (
        <CriticalBloodPressureModal
          isOpen={openPressureMinModal}
          activityId={readingId}
          activityDate={createdAt}
          closeModal={toggleOpenPressureMin}
          handleSubmit={(msg: string) => {
            updateAction({
              idx,
              action: { message: msg, isTemplateBased: true },
            });
          }}
          values={values}
          type="min"
          patientGuid={patientGuid}
          idx={idx}
        />
      )}

      {isOpenAssessmentModalMap.glucose && readingCriticalType && (
        <CriticalBloodGlucoseModal
          isOpen={isOpenAssessmentModalMap.glucose}
          activityId={readingId}
          closeModal={() => toggleAssessmentModal('glucose')}
          handleSubmit={(msg: string) => {
            updateAction({
              idx,
              action: { message: msg, isTemplateBased: true },
            });
          }}
          type={readingCriticalType}
          patientGuid={patientGuid}
          idx={idx}
          activityDate={createdAt}
          values={values}
        />
      )}

      {isOpenAssessmentModalMap.spo2 && (
        <CriticalSpo2Modal
          isOpen={isOpenAssessmentModalMap.spo2}
          activityId={readingId}
          closeModal={() => toggleAssessmentModal('spo2')}
          handleSubmit={(msg: string) => {
            updateAction({
              idx,
              action: { message: msg, isTemplateBased: true },
            });
          }}
          type="min"
          idx={idx}
          activityDate={createdAt}
          values={values}
          patientGuid={patientGuid}
        />
      )}

      {isOpenAssessmentModalMap.pulse && (
        <CriticalPulseModal
          isOpen={isOpenAssessmentModalMap.pulse}
          activityId={readingId}
          closeModal={() => toggleAssessmentModal('pulse')}
          handleSubmit={(msg: string) => {
            updateAction({
              idx,
              action: { message: msg, isTemplateBased: true },
            });
          }}
          type={pulseMaxCritical ? 'max' : 'min'}
          idx={idx}
          activityDate={createdAt}
          values={values}
          patientGuid={patientGuid}
        />
      )}

      {isOpenAssessmentModalMap.chfWeight && (
        <CriticalChfWeightModal
          isOpen={isOpenAssessmentModalMap.chfWeight}
          activityId={readingId}
          closeModal={() => toggleAssessmentModal('chfWeight')}
          handleSubmit={(msg: string) => {
            updateAction({
              idx,
              action: { message: msg, isTemplateBased: true },
            });
          }}
          type="max"
          idx={idx}
          activityDate={createdAt}
          values={values}
          patientGuid={patientGuid}
        />
      )}

      {isOpenAssessmentModalMap.weight && (
        <CriticalWeightModal
          isOpen={isOpenAssessmentModalMap.weight}
          activityId={readingId}
          closeModal={() => toggleAssessmentModal('weight')}
          handleSubmit={(msg: string) => {
            updateAction({
              idx,
              action: { message: msg, isTemplateBased: true },
            });
          }}
          type="max"
          idx={idx}
          activityDate={createdAt}
          values={values}
          patientGuid={patientGuid}
        />
      )}
    </>
  );
};

export default RpmAlertAssessmentModals;
